// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__jEOjc","productName":"Table_productName__3Lr18"};